import React, {createContext, useState} from 'react'
import axios from 'axios';




const Context = createContext()



let userislogin = false

if(sessionStorage.getItem(`${process.env.REACT_APP_EVENTO_ID}index-Nombre_USERRADIO`) !== null){
    userislogin = true
}else{
    userislogin = false
}


//const _URL_REST = globals.get('_URL_REST');
const Provider = ({children}) => {
    const [isAuth, setIsAuth] = useState(userislogin)
    const [header, setHeader] = useState({ 'title': 't', 'subtitle': 's'})

    const value = {
        isAuth,
        header,
        activateAuth: () =>{
            setIsAuth(true)
        },
        removeAuth: () =>{
            //console.log('Close')
            sessionStorage.clear()
            setIsAuth(false)
        },
       
        getHeader: async (id) => {
            const result = await axios(
                `https://webinars.spinmedia.es:3018/getsettings/${id}`,
            );
            setHeader( { 'title': result.data[0].cabeceraTitulo, 'subtitle': result.data[0].cabeceraSubtitulo})
        }
        
    }


    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    )
}



export default{
    Provider,
    Consumer: Context.Consumer
}